import { Body, Flex, Heading, Image } from '@hover/blueprint';
import { iExternalLink } from '@hover/icons';
import React from 'react';

import connectPro from 'src/assets/img/homeownerApp/modules/linkOuts/connectPro.png';
import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks';
import { Button } from 'src/shared/components';
import type { FeatureFlag } from 'src/shared/constants';
import { linkPressed } from 'src/shared/telemetry';

import { PROJECT_DETAILS_PADDING } from './ProjectCardSection';

export const ConnectPro = ({
  projectId,
  config,
}: {
  projectId: string;
  config: Partial<FeatureFlag.ComingSoonLinkouts>;
}) => {
  const { trackingData } = useHomeownerAppContext();

  if (!config?.connectPro) return null;

  return (
    <Flex
      bgColor="neutral.100"
      boxSizing="border-box"
      direction="column"
      p={PROJECT_DETAILS_PADDING}
      width="100%"
    >
      <Image
        alt=""
        borderRadius={300}
        mb={400}
        objectFit="cover"
        src={connectPro}
        width="96px"
      />
      <Heading as="h2" mb={0} size={500}>
        {config.connectPro.title}
      </Heading>
      <Body m={0} size={400}>
        {config.connectPro.description}
      </Body>
      <Button
        align-self="flex-end"
        as="a"
        href={config.connectPro.buttonHref}
        iconAfter={iExternalLink}
        includeTrackingImpression
        mt={500}
        optionalTrackingProperties={{
          destination_url: config.connectPro.buttonHref,
          track_id: 'connect-with-pro-link-out',
          link_location: 'Connect with Pro Tile',
          project_id: Number(projectId),
          ...trackingData,
        }}
        target="_blank"
        textDecoration="none"
        track={linkPressed}
        width="min-content"
      >
        {config.connectPro.buttonText}
      </Button>
    </Flex>
  );
};
